/* eslint-disable react-refresh/only-export-components -- Table de constantes partagée ; elle
   contient du JSX (les icônes) et doit donc rester un `.tsx`, mais n'exporte aucun composant. */
import React                   from 'react';
import { FontSizeOutlined }    from '@ant-design/icons';
import { GlobalOutlined }      from '@ant-design/icons';
import { NumberOutlined }      from '@ant-design/icons';
import { LinkOutlined }        from '@ant-design/icons';
import { BgColorsOutlined }    from '@ant-design/icons';
import { PictureOutlined }     from '@ant-design/icons';

/**
 * Les six natures que l'API sait stocker (`Map_FieldTypeReference`), décrites par ce qu'elles
 * PRODUISENT sur la fiche d'un point d'intérêt plutôt que par leur nom technique : "champ" ne veut
 * rien dire à qui découvre, "une adresse web, cliquable depuis la carte publiée" se comprend seul.
 *
 * Partagées par le sélecteur d'ajout, la liste et l'aperçu, pour qu'une nature ait partout la même
 * icône et le même nom.
 */
export const NATURES: {
	reference: Map_FieldTypeReference;
	label: string;
	hint: string;
	icon: React.ReactNode;
}[] = [
	{ reference: 'string', label: 'Texte', hint: 'Une ligne ou un paragraphe libre.', icon: <FontSizeOutlined /> },
	{ reference: 'translatable', label: 'Texte multilingue', hint: 'Un texte par langue du projet.', icon: <GlobalOutlined /> },
	{ reference: 'number', label: 'Nombre', hint: 'Un entier ou un décimal — étage, capacité…', icon: <NumberOutlined /> },
	{ reference: 'url', label: 'Lien', hint: 'Une adresse web, cliquable depuis la carte publiée.', icon: <LinkOutlined /> },
	{ reference: 'color', label: 'Couleur', hint: 'Une couleur choisie dans un nuancier.', icon: <BgColorsOutlined /> },
	{ reference: 'image', label: 'Image', hint: 'Un fichier déposé, affiché sur la fiche.', icon: <PictureOutlined /> },
];
